"use client";

import { httpsCallable } from "firebase/functions";
import type { SavedPublicVoice, TtsModelId } from "@reelmagic/domain";
import { getFirebaseClientServices } from "../firebase/client";

export async function savePublicVoice(input: { modelId: TtsModelId; providerVoiceId: string; label: string }) {
  const { functions } = getFirebaseClientServices();
  const result = await httpsCallable<Record<string, unknown>, SavedPublicVoice>(functions, "managePublicVoice")({ ...input, action: "save" });
  return result.data;
}

export async function removePublicVoice(input: { modelId: TtsModelId; providerVoiceId: string }) {
  const { functions } = getFirebaseClientServices();
  await httpsCallable<Record<string, unknown>, { removed: boolean }>(functions, "managePublicVoice")({ ...input, action: "remove" });
}
